import {c as createCommonjsModule, g as getDefaultExportFromCjs} from "./_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "./interopRequireDefault-d2c9da36.js";
import {o as objectWithoutPropertiesLoose, _ as _extends_1, e as esm} from "./defaultTheme-ca6a0b43.js";
import React from "react";
import {p as propTypes} from "./index-877ea290.js";
import {r as require$$3} from "./clsx.m-5dc7436b.js";
import {c as core} from "./index-0a000c27.js";
import {u as useThemeProps_1, s as styled_1} from "./useThemeProps-ef190a94.js";
import {L as ListContext_1} from "./ListContext-0f0f18c4.js";
import {B as ButtonBase} from "./index-ef2a811c.js";
import {u as useEnhancedEffect} from "./useEnhancedEffect-d69b40f2.js";
import {u as useForkRef} from "./useForkRef-b591be37.js";
import {D as Divider} from "./index-ccfa435e.js";
import {L as ListItemIcon} from "./index-2bc6141b.js";
import {L as ListItemText} from "./index-22a68b0c.js";
import _jsxRuntime from "react/jsx-runtime";
var menuItemClasses_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  exports.getMenuItemUtilityClass = getMenuItemUtilityClass;
  function getMenuItemUtilityClass(slot) {
    return (0, core.generateUtilityClass)("MuiMenuItem", slot);
  }
  const menuItemClasses = (0, core.generateUtilityClasses)("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]);
  var _default = menuItemClasses;
  exports.default = _default;
});
var MenuItem_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.overridesResolver = exports.default = void 0;
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var _extends2 = interopRequireDefault(_extends_1);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _clsx = interopRequireDefault(require$$3);
  var _styled = _interopRequireWildcard(styled_1);
  var _useThemeProps = interopRequireDefault(useThemeProps_1);
  var _ListContext = interopRequireDefault(ListContext_1);
  var _ButtonBase = interopRequireDefault(ButtonBase);
  var _useEnhancedEffect = interopRequireDefault(useEnhancedEffect);
  var _useForkRef = interopRequireDefault(useForkRef);
  var _menuItemClasses = _interopRequireWildcard(menuItemClasses_1);
  const _excluded = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const overridesResolver = (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.dense && styles.dense, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters];
  };
  exports.overridesResolver = overridesResolver;
  const useUtilityClasses = (ownerState) => {
    const {
      disabled,
      dense,
      divider,
      disableGutters,
      selected,
      classes
    } = ownerState;
    const slots = {
      root: ["root", dense && "dense", disabled && "disabled", !disableGutters && "gutters", divider && "divider", selected && "selected"]
    };
    const composedClasses = (0, core.unstable_composeClasses)(slots, _menuItemClasses.getMenuItemUtilityClass, classes);
    return (0, _extends2.default)({}, classes, composedClasses);
  };
  const MenuItemRoot = (0, _styled.default)(_ButtonBase.default, {
    shouldForwardProp: (prop) => (0, _styled.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver
  })(({
    theme,
    ownerState
  }) => (0, _extends2.default)({}, theme.typography.body1, {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    position: "relative",
    textDecoration: "none",
    minHeight: 48,
    paddingTop: 6,
    paddingBottom: 6,
    boxSizing: "border-box",
    whiteSpace: "nowrap"
  }, !ownerState.disableGutters && {
    paddingLeft: 16,
    paddingRight: 16
  }, ownerState.divider && {
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundClip: "padding-box"
  }, {
    "&:hover": {
      textDecoration: "none",
      backgroundColor: theme.palette.action.hover,
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    [`&.${_menuItemClasses.default.selected}`]: {
      backgroundColor: (0, esm.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      [`&.${_menuItemClasses.default.focusVisible}`]: {
        backgroundColor: (0, esm.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
      }
    },
    [`&.${_menuItemClasses.default.selected}:hover`]: {
      backgroundColor: (0, esm.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
      "@media (hover: none)": {
        backgroundColor: (0, esm.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
      }
    },
    [`&.${_menuItemClasses.default.focusVisible}`]: {
      backgroundColor: theme.palette.action.focus
    },
    [`&.${_menuItemClasses.default.disabled}`]: {
      opacity: theme.palette.action.disabledOpacity
    },
    [`& + .${Divider.dividerClasses.root}`]: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    [`& + .${Divider.dividerClasses.inset}`]: {
      marginLeft: 52
    },
    [`& .${ListItemText.listItemTextClasses.root}`]: {
      marginTop: 0,
      marginBottom: 0
    },
    [`& .${ListItemText.listItemTextClasses.inset}`]: {
      paddingLeft: 36
    },
    [`& .${ListItemIcon.listItemIconClasses.root}`]: {
      minWidth: 36
    }
  }, !ownerState.dense && {
    [theme.breakpoints.up("sm")]: {
      minHeight: "auto"
    }
  }, ownerState.dense && (0, _extends2.default)({
    minHeight: 32,
    paddingTop: 4,
    paddingBottom: 4
  }, theme.typography.body2, {
    [`& .${ListItemIcon.listItemIconClasses.root} svg`]: {
      fontSize: "1.25rem"
    }
  })));
  const MenuItem2 = /* @__PURE__ */ React$1.forwardRef(function MenuItem3(inProps, ref) {
    const props = (0, _useThemeProps.default)({
      props: inProps,
      name: "MuiMenuItem"
    });
    const {
      autoFocus = false,
      component = "li",
      dense = false,
      divider = false,
      disableGutters = false,
      focusVisibleClassName,
      role = "menuitem",
      tabIndex: tabIndexProp
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const context = React$1.useContext(_ListContext.default);
    const childContext = {
      dense: dense || context.dense || false,
      disableGutters
    };
    const menuItemRef = React$1.useRef(null);
    (0, _useEnhancedEffect.default)(() => {
      if (autoFocus) {
        if (menuItemRef.current) {
          menuItemRef.current.focus();
        }
      }
    }, [autoFocus]);
    const ownerState = (0, _extends2.default)({}, props, {
      dense: childContext.dense,
      divider,
      disableGutters
    });
    const classes = useUtilityClasses(props);
    const handleRef = (0, _useForkRef.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) {
      tabIndex = tabIndexProp !== void 0 ? tabIndexProp : -1;
    }
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_ListContext.default.Provider, {
      value: childContext,
      children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(MenuItemRoot, (0, _extends2.default)({
        ref: handleRef,
        role,
        tabIndex,
        component,
        focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName)
      }, other, {
        ownerState,
        classes
      }))
    });
  });
  var _default = MenuItem2;
  exports.default = _default;
});
var MenuItem = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    menuItemClasses: true
  };
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _MenuItem.default;
    }
  });
  Object.defineProperty(exports, "menuItemClasses", {
    enumerable: true,
    get: function() {
      return _menuItemClasses.default;
    }
  });
  var _MenuItem = interopRequireDefault(MenuItem_1);
  var _menuItemClasses = _interopRequireWildcard(menuItemClasses_1);
  Object.keys(_menuItemClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _menuItemClasses[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _menuItemClasses[key];
      }
    });
  });
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(MenuItem);
export {MenuItem as M, __pika_web_default_export_for_treeshaking__ as _};
